export class JobSalary {
    constructor() {
        this.maxSalary = 0;
        this.minSalary = 0;
        this.salaryType = null;
        this.salaryDuration = "PER_MONTH";
        this.currency = null;
    }
}
//# sourceMappingURL=jobSalary.js.map